<template>
    <div>
        <nav-breadcrumb :menu="[{label: noticeId ? '编辑通知' : '新增通知'}]"/>
        <el-row>
            <el-col>
                <panel label="基本信息">
                    <el-form :model="dataForm" :rules="dataFormRules" ref="dataForm" label-width="150px">
                        <el-row :gutter="10" class="bg-purple xamhtrpg">
                            <el-col :span="24">
                                <el-form-item label="标题：" prop="n__title" :rules="{required: true, message: '标题不能为空'}" style="width: 60%">
                                    <el-input v-model="dataForm.n__title"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="开始日期：" prop="n__frDate" :rules="{required: true, message: '开始日期不能为空'}" style="width: 60%">
                                    <el-date-picker
                                        v-model="dataForm.n__frDate"
                                        value-format="yyyy-MM-dd"
                                        type="date"
                                        placeholder="选择日期">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="结束日期：" prop="n__toDate" :rules="{required: true, message: '结束日期不能为空'}" style="width: 60%">
                                    <el-date-picker
                                        v-model="dataForm.n__toDate"
                                        value-format="yyyy-MM-dd"
                                        type="date"
                                        placeholder="选择日期">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="通知内容：" prop="n__content" :rules="{required: true, message: '通知内容不能为空'}" style="width: 60%">
                                    <el-input type="textarea" v-model="dataForm.n__content" style="margin-bottom:10px;"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <div class="tr xzmt">
                            <el-button type="primary" @click="onSubmit('dataForm')">确认提交</el-button>
                            <el-button @click="$router.back()">取消</el-button>
                        </div>
                    </el-form>
                </panel>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    export default {
        name: "BranchNoticeAdd",
        data() {
            return {
                noticeId:this.$route.query['noticeId']||'',
                dataForm:{},
                dataFormRules:{},
            }
        },
        mounted() {
            if(this.noticeId){
                this.getData()

            }
        },
        methods:{
            getData:function(){
                xhr.getBranchNotice({
                        'n.noticeId': this.noticeId
                    },
                    res=> {
                        try{
                            if(res.data.status == 'success') {
                                this.dataForm = res.data.data
                            }
                        }catch (e) {

                        }
                    })
            },
            onSubmit: function (formName) {
                let dataForm = this.dataForm
                this.$refs[formName].validate(valid=> {
                    if (valid) {
                        dataForm.n__checked = true
                        xhr.updateBranchNotice(dataForm, res=> {
                            try {
                                if (res.data.status == 'success') {
                                    this.$router.push({
                                        name: 'BranchNoticeListView'
                                    })
                                }
                            } catch (e) {
                            }
                        })
                    }
                })
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/branchoffice/BranchNoticeAdd.vue